import {
  Ard,
  UseCaseName,
  UslLine,
} from "@amzn/fuse-accounting-central-datastore-client";

export const URLS = {
  MAIN_PAGE: "/transactionsearch",
  GET_PLAN: "/getplan",
  GET_ARD: "/getard",
  UPDATE_PLAN: "/updateplan",
  RAGA_AVAILABILITIES: "/ragaavailabilities",
  REDRIVE_WORKFLOW: "/redriveworkflow",
  BULK_REDRIVE_WORKFLOW: "/bulkredriveworkflow",
  BULK_REDRIVE_STATUS: "/bulkredrivestatus",
  BART_AUDIT_HISTORY: "/bartaudithistory",
  DLQ_MOVER: "/bartdlqmoverworkflow",
  GET_WORKFLOW_STATUS: "/getworkflowstatus",
  LINK_ARD_TO_A_PLAN: "/remappingardtoplan",
  ARD_NEW_PLAN_MAPPING: "/ardnewplanmapping",
  JEM_GEN: "/jemgen",
  GET_FIXED_FEE_CONFIG: "/getfixedfeeconfig",
  LIST_ALL_FIXED_FEE_CONFIGS: "/viewallfixedfeeconfigs",
  JEM_VALIDATION: "/jemvalidation",
  UNBILLED_AR_AGING: "/unbilledaraging",
};

export const EXTERNAL_SERVICES = {
  TINY_URL: "https://tiny.amazon.com/submit/url",
  FRAMES: "https://frames.finance-tech.a2z.com/codes",
  FLARE: "https://flare.aka.amazon.com/flash/config/domain",
};

export const BLANK_ARD: Ard = {
  id: "",
  product: undefined,
  template: undefined,
  term: undefined,
  billingMode: undefined,
  businessCountryCode: "",
  buyingCustomerCountryCode: "",
  functionalCurrency: "",
  localCurrency: "",
  clientId: "",
  deploymentStage: undefined,
  usecases: [],
};

export const USL_LINE_KEY_TO_HEADER: Record<keyof UslLine, string> = {
  companyCode: "Company Code",
  location: "Location",
  costCenter: "Cost Center",
  accountNumber: "Account Number",
  productLine: "Product Line",
  channel: "Channel",
  project: "Project",
  debitOrCredit: "Debit/Credit",
  glLineDescriptionSuffix: "GL Line Description Suffix",
  subscriptionProductLine: "Subscription Product Line",
  invoiceAccountingClass: "Accounting Class Code",
};

export const STANDARD_USE_CASE_NAMES = Object.values(UseCaseName).filter(
  (name) => name !== UseCaseName.OTHER,
) as UseCaseName[];
